import * as React from "react";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { PRODUCT_ICON } from "../../../common/enum/productIcon";
import { Avatar } from "@mui/material";

const StyledSwitch = styled(Switch)(({ theme }) => ({
  width: 70,
  height: 30,
  padding: 12,
  "& .MuiSwitch-switchBase": {
    margin: 2,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(38px)",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#37B34A",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#fff",
    width: 24,
    height: 24,
    border: "2px solid #37B34A",
    borderRaidus: "50%",
    "&:before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
    borderRadius: 20 / 2,
  },
}));

const FilterSwitch = ({
  filterLabel,
  filterObject,
  filterState,
  setFilterState,
  handleChangeFilterType,
  t,
}) => {
  const handleChange = (event) => {
    setFilterState({
      ...filterState,
      [event.target.name]: event.target.checked,
    });
  };

  return (
    <FormControl
      component="fieldset"
      variant="standard"
      sx={{ minWidth: "200px" }}
    >
      <FormLabel component="legend" sx={{fontWeight:600,fontSize:"12px"}}>{t(`${filterLabel}`)}</FormLabel>
      <FormGroup sx={{ alignItems: "flex-start" }}>
        {Object.keys(filterObject).map((item) => (
          <Stack direction={"row"} alignItems={"center"} key={item} width={1}>
            {PRODUCT_ICON.find((pro) => pro.productGroup === item) !==
              undefined && (
              <Avatar
                src={PRODUCT_ICON.find((pro) => pro.productGroup === item)?.url}
                alt={item}
                variant="circular"
                sx={{ width: 18, height: 18, mr: 1 }}
              />
            )}
            <FormControlLabel
              key={item}
              control={
                <StyledSwitch
                  checked={filterState[item] || false}
                  onChange={(event) => {
                      handleChange(event);
                      handleChangeFilterType?.(event);
                  }}
                  name={item}
                />
              }
              labelPlacement="start"
              label={<Typography sx={{fontWeight:600}}>{t(`${item}`)}</Typography>}
              sx={{
                ml: 0,
                width: 1,
                justifyContent: "space-between",
                whiteSpace: "break-spaces",
              }}
            />
          </Stack>
        ))}
      </FormGroup>
    </FormControl>
  );
};

export default FilterSwitch;
